import { type JSX, useCallback } from 'react';

import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';

import { PageContent } from '@/components';
import { ThemeFilters, ThemeHeader } from '@/features/themes';
import { ThemesToolbar } from '@/features/themes/components/ThemesTabs';
import { ThemesProvider } from '@/features/themes/context/ThemesProvider';
import { themesSearchParamsSchema, type ThemesSearchParams } from '@/features/themes/lib/themesSearchParams.schema';
import { requireAuthenticated } from '@/permissions';

export const Route = createFileRoute('/banco-de-temas')({
  staticData: { title: 'Busca de temas' },
  beforeLoad: requireAuthenticated(),
  validateSearch: (search: Record<string, unknown>): ThemesSearchParams => themesSearchParamsSchema.parse(search),
  component: BancoDeTemasLayout,
});

function BancoDeTemasLayout(): JSX.Element {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const handleNavigate = useCallback(
    ({ search: nextSearch, replace }: { search: ThemesSearchParams; replace?: boolean }) => {
      void navigate({ search: nextSearch, replace });
    },
    [navigate]
  );

  return (
    <ThemesProvider
      search={search}
      navigate={handleNavigate}>
      <ThemeHeader />
      <PageContent>
        <ThemeFilters />
        <ThemesToolbar />
        <Outlet />
      </PageContent>
    </ThemesProvider>
  );
}
